import React from 'react';
import InputField from './InputField';
import SubmitButton from './SubmitButton';
import UserStore from '../stores/UserStore';

class LoginForm extends React.Component {

  constructor(props){
    super(props);
    this.state ={
      username: '',
      password: '',
      buttonDisabled: false,
      error: ''
    }
  }

  setInputValue(property, val){
    val = val.trim();

    this.setState({
      [property]: val
    })
  }

  resetForm(){
    this.setState({
      username: '',
      password: '',
      buttonDisabled: false,
      error: ''
    })
  }

    onSubmit = async (e) => {
        // For safety if someone wraps this in a <form> later:
        if (e && typeof e.preventDefault === 'function') e.preventDefault();

        if (!this.state.username || !this.state.password) {
            this.setState({ error: 'Please enter both username and password' });
            return;
        }

        this.setState({ buttonDisabled: true, error: '' });
        try {
            await UserStore.login(this.state.username, this.state.password);
            
            // Fetch user profile after successful login
            const token = await UserStore.getAccessToken();
            const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api-prod.valueguard.se'}/v0/users/me?access_token=${token}`);
            
            if (response.ok) {
                const userData = await response.json();
                UserStore.setProfileFromMe(userData);
                UserStore.saveToSession();
                
                // Redirect based on user roles - mapstat users go to mapstat, otherwise bostadsregistret
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                } else {
                    const hasMapstat = UserStore.hasRole('MAPSTAT2:BASIC');
                    const hasBostadsregistret = UserStore.hasRole('API_SERVICE2:BOSTADSREGISTRET');
                    if (hasMapstat) {
                        window.location.href = '/mapstat';
                    } else if (hasBostadsregistret) {
                        window.location.href = '/bostadsregistret';
                    } else {
                        window.location.href = '/';
                    }
                }
            }
        } catch (err) {
            console.error('login failed', err);
            this.setState({ 
                buttonDisabled: false,
                error: err.message || 'Login failed'
            });
        }
    };


    render() {
        return (
            <div className="loginForm">
                Log in
                {this.state.error && (
                    <div className="alert alert-danger" role="alert">
                        {this.state.error}
                    </div>
                )}
                <InputField
                    type="text"
                    placeholder="Username"
                    value={this.state.username}
                    onChange={(val) => this.setInputValue('username', val)}
                />

                <InputField
                    type="password"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={(val) => this.setInputValue('password', val)}
                />

                <SubmitButton
                    text={this.state.buttonDisabled ? "Logging in..." : "Login"}
                    type="button"
                    disabled={this.state.buttonDisabled}
                    onClick={this.onSubmit}
                />
            </div>
        );
    }
}

export default LoginForm;
